import {DialogTitle, CardContent, Box, Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

import MuiModal from 'components/modal/Modal';

export const StyledCardContentWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(1, 0, 0, 1),
  cursor: 'pointer',
  '& > div:last-child': {
    flex: 1,
    maxWidth: 'calc(100% - 60px)'
  }
}));

export const StyledCardContent = styled(CardContent)(({theme}) => ({
  padding: theme.spacing(0),
  '&.MuiCardContent-root': {
    padding: theme.spacing(0, 2, 0, 2)
  }
}));

export const StyledTitleTypography = styled(Typography)<TypographyProps>(() => ({
  display: 'block',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: 1
}));

export const UpchargeInfoContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  marginTop: theme.spacing(2),
  fontSize: '14px',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  backgroundColor: '#ECF9FF'
}));

export const StyledContetTypography = styled(Typography)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: 1.2,
  margin: '15px',
  width: '416px'
}));

export const StyledPriceTypography = styled(Typography)(() => ({
  fontWeight: 'bold',
  marginLeft: '5px'
}));

export const StyledUpTitleTypography = styled(Typography)(() => ({
  height: '46px',
  fontWeight: 'bold',
  fontSize: '20px',
  lineHeight: '30px'
}));

export const StyledPriceContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  marginTop: '10px'
}));

export const StyledModal = styled(MuiModal)(({theme}) => ({
  '.MuiPaper-root': {
    margin: theme.spacing('auto', 2),
    maxWidth: '100%',
    [theme.breakpoints.up('desktop')]: {
      margin: theme.spacing('auto', 4),
      maxWidth: theme.spacing(100)
    }
  },

  '.MuiDialogContent-root': {
    padding: 0
  }
}));

export const ModalContent = styled('div')(({theme}) => ({
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  [theme.breakpoints.up('tablet')]: {
    marginBottom: theme.spacing(1)
  },
  maxHeight: '44.25rem'
}));

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  fontSize: '20px',
  alignItems: 'flex-start',
  fontWeight: '700',
  padding: theme.spacing(2, 2, 1.5, 2),
  maxWidth: '448px',
  maxHeight: '56px'
}));

export const StyledDiscountDescription = styled('div')(() => ({
  maxWidth: '23.438rem',
  minWidth: '12rem'
}));
